module.exports = __webpack_public_path__ + "img/lt_project_details.226a94fa.png";